import React from "react";

const Else_If = () => {
  return (
    <div>
      <h1>Else_If Component</h1>
      <p>Content for Else_If goes here...</p>
    </div>
  );
};

export default Else_If;
